import { Component, ChangeDetectionStrategy } from '@angular/core';
import { OUTLOOK_SHARED_UI } from '@maximizer/outlook/shared/ui';

@Component({
  selector: 'maximizer-outlook-iq-boost-skeleton',
  imports: [OUTLOOK_SHARED_UI],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="pt-6 pb-4">
      <maximizer-outlook-skeleton
        containerClasses="h-6 w-full rounded bg-neutral-20"
        fullWidth="full"
      ></maximizer-outlook-skeleton>
    </div>

    <div class="class flex flex-col gap-2">
      <maximizer-outlook-skeleton
        containerClasses="h-6 w-1/2 rounded bg-neutral-20"
        fullWidth="none"
      ></maximizer-outlook-skeleton>
      <maximizer-outlook-skeleton
        containerClasses="h-12 w-full rounded bg-neutral-20"
        fullWidth="full"
      ></maximizer-outlook-skeleton>
      <maximizer-outlook-skeleton
        containerClasses="h-12 w-full rounded bg-neutral-20"
        fullWidth="full"
      ></maximizer-outlook-skeleton>
      <maximizer-outlook-skeleton
        containerClasses="h-12 w-full rounded bg-neutral-20"
        fullWidth="full"
      ></maximizer-outlook-skeleton>
    </div>

    <div class="class flex-col gap-2 pt-12 hidden h-sm:flex">
      <maximizer-outlook-skeleton
        containerClasses="h-6 w-1/2 rounded bg-neutral-20"
        fullWidth="none"
      ></maximizer-outlook-skeleton>
      <maximizer-outlook-skeleton
        containerClasses="h-12 w-full rounded bg-neutral-20"
        fullWidth="full"
      ></maximizer-outlook-skeleton>
      <maximizer-outlook-skeleton
        containerClasses="h-12 w-full rounded bg-neutral-20"
        fullWidth="full"
      ></maximizer-outlook-skeleton>
      <maximizer-outlook-skeleton
        containerClasses="h-12 w-full rounded bg-neutral-20"
        fullWidth="full"
      ></maximizer-outlook-skeleton>
    </div>
  `,
})
export class OutlookIqBoostSkeletonComponent {}
